import { Dispatch } from 'redux';
import { queryAllFlights, queryFlightsOnly, getFlight, deleteFlight } from '../../services/api';
import { intl } from '../../providers/IntlProvider';
import { ToastCategories, ToastTypes, ToastsActionTypes } from '../toasts';
import { FlightsActionTypes } from '.';

interface FlightsPayload {
  payload: {
    page: number;
    current: number;
    limit: number;
    sort_column?: string;
    sort_order?: string;
    aircraft_ids?: string[];
    status?: string[];
  };
}

export const getAllFlights =
  ({ payload }: FlightsPayload) =>
    async (dispatch: Dispatch): Promise<void> => {
    const response = await queryAllFlights(payload);
    dispatch({
      type: FlightsActionTypes.SAVE_ALL,
      payload: response,
    });
  };

export const getFlightsForAircraft =
  ({ payload }: { payload: { id: string } }) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await queryFlightsOnly(payload);
    if (response && response.res && response.res.status > 199 && response.res.status < 399) {
      dispatch({
        type: FlightsActionTypes.SAVE_FLIGHTS_ONLY,
        payload: { flights: response.data, aircraftId: payload.id },
      });
    }
  };

export const getFlightDetails =
  ({ payload }: { payload: string }) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await getFlight(payload);
    dispatch({
      type: FlightsActionTypes.SAVE_FLIGHT_DETAILS,
      payload: response,
    });
  };

export const saveParams =
  ({ payload }: { payload: FlightsPayload }) =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch({
      type: FlightsActionTypes.SET_PARAMS,
      payload,
    });
  };

export const saveFilters =
  ({ payload }: { payload: { aircraft_ids?: string[]; status?: string[] } }) =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch({
      type: FlightsActionTypes.SET_FILTERS,
      payload,
    });
  };

export const setFlightsDirty =
  ({ payload }: { payload: boolean }) =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch({
      type: FlightsActionTypes.SET_DIRTY,
      payload,
    });
  };

export const deleteFlightEntry =
  ({ payload, sectorNameOverride }:
    { payload: { id: string; aircraftId: string }; sectorNameOverride: string }, callBack = null) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await deleteFlight(payload);
    if (response && response.statusCode > 199 && response.statusCode < 400) {
      if (callBack) {
        callBack();
      }
      dispatch({
        type: FlightsActionTypes.DELETE_FLIGHT,
        payload,
      });
      dispatch({
        type: ToastsActionTypes.ADD_TOAST,
        payload: {
          title: intl.formatMessage({ id: 'message.sectorRemoved' }, { sector: sectorNameOverride }),
          type: ToastTypes.SUCCESS,
          category: ToastCategories.FLASH,
          message: '',
        },
      });
    } else {
      dispatch({
        type: ToastsActionTypes.ADD_TOAST,
        payload: {
          title: intl.formatMessage(
            { id: 'message.sectorRemoveFailed' },
            { sector: sectorNameOverride.toLowerCase() },
          ),
          type: ToastTypes.ERROR,
          category: ToastCategories.FLAG,
          message: '',
        },
      });
    }
  };
